import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const subkonMangkirService = {}

// List data mangkir subkon
subkonMangkirService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/subkon_mangkir/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

subkonMangkirService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/subkon_mangkir/data_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

subkonMangkirService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/subkon_mangkir/empty_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

subkonMangkirService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/subkon_mangkir/save_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default subkonMangkirService;
